
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
    Input,
    Checkbox,
    Button,
    Textarea,
  } from "@material-tailwind/react";
import { FaCheck } from "react-icons/fa";
import { FaRegCircleCheck, FaUser } from "react-icons/fa6";
import { HiUser } from "react-icons/hi";
import { HiEnvelope, HiOutlineBuildingLibrary, HiOutlineEnvelope, HiOutlineUser } from "react-icons/hi2";
import { AiOutlinePhone } from "react-icons/ai";
import { useContext, useState } from "react";
import { OrderContext } from "../../context/order.context";
import { IoWarning } from "react-icons/io5";
import { successToast } from "../../utils/firebase/firebase.utils";
import imageCompression from "browser-image-compression";
import { generateRandomString, handleFileSelect } from "../../hooks/fileupload";
   
  export function TranslationCard() {

    const { addInquiry } = useContext(OrderContext);

    const defaultValues = {
      org: '',
      fname: '',
      sname: '',
      name: '',
      email: '',
      phone: '',
      message: '',
      status: 'no',
      fileinc: 'no',
      type: 'translation',
      del: 'no',
      created_at: new Date(),
      updated_at: null,
    }
    
    const [ inquire, setInquire ] = useState(false);
    const [ inquiryText, setInquirText ] = useState('');
    const [ formFields, setFormFields ] = useState(defaultValues);

    const [compressionStatus, setCompressionStatus] = useState("Idle");
    const [downloadURL, setDownloadURL] = useState("");

    const [files, setFiles] = useState([]);
    const [compressedFiles, setCompressedFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    // const [compressionStatus, setCompressionStatus] = useState([]); // Track compression status
    const maxTotalSize = 15 * 1024 * 1024; // 15MB in bytes
  

    const changeFieldText = (event) => {
      const { name, value } = event.target;
      setFormFields({...formFields, [name]: value})
      // console.log(value)
    }

    const submitInquiry = async (event) => {
      // event.preventDefault()
      // return successToast("Submitted Now!")
      
      formFields['name'] = `${formFields.fname} ${formFields.sname}`.trim();
      console.log(formFields)

      await addInquiry(formFields, 'Request').then(
        setInquirText('y'),
        setInquire(!inquire),
        setFormFields(defaultValues)
      );
    };

    const checkFileSize = async (event) => {
      event.preventDefault()
      console.log('Upload Started')
      const selectedFiles = Array.from(event.target.upfiles.files);

      if (selectedFiles.length != 0) {
        // return console.log('11')
    
        // Calculate the total size of the selected files console.log('File Limit: ', maxTotalSize)
        const totalSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);
        

        if (totalSize > maxTotalSize) {
          console.log('File limit reached..!')
          return alert(`Upload limit of 15MB exceeded.`);
        }
        const dPath = event.target.fname.value + generateRandomString(7);
        handleFileSelect(selectedFiles, dPath, setCompressionStatus, setDownloadURL).then(() => {
          formFields['fileinc'] = dPath
          // formFields['filePath'] = downloadURL
          submitInquiry()
        });
      }else{
        submitInquiry()
      }

      // await addInquiry(formFields).then(
      //   setInquirText('y'),
      //   setInquire(!inquire),
      //   setFormFields(defaultValues)
      // );
      // //https://firebasestorage.googleapis.com/v0/b/cakebysandy-a4e24.appspot.com/o/compressed_files%2FJudy6m43g7V.zip?alt=media&token=86302edc-6fbe-4714-aab4-4372078f2a75
      // //https://firebasestorage.googleapis.com/v0/b/cakebysandy-a4e24.appspot.com/o/compressed_files%2FJudylmV1w8q.zip?alt=media&token=2ef7ee3d-6740-4022-b1f3-b9e1d385d161
    }



    // Handle file selection
    const handleFileSelect24 = async (event) => {
      console.log('Upload Started')
      const selectedFiles = Array.from(event.target.files);
    
      // Calculate the total size of the selected files console.log('File Limit: ', maxTotalSize)
      const totalSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);
      

      if (totalSize > maxTotalSize) {
        console.log('File limit reached..!')
        return alert(`Upload limit of 15MB exceeded.`);
      }
      // return console.log('Total File Size: ', totalSize)
      setFiles(selectedFiles); // Only set files if the total size is within the limit
    

      // Initialize compression status
      const initialStatus = selectedFiles.map((file) => ({
        name: file.name,
        status: "Pending", // Initial status
      }));
      setCompressionStatus(initialStatus);

      // Compress files
      const compressedFiles = await Promise.all(
        selectedFiles.map(async (file, index) => {
          try {
            // Update status to "Compressing"
            setCompressionStatus((prevStatus) =>
              prevStatus.map((status, i) =>
                i === index ? { ...status, status: "Compressing..." } : status
              )
            );

            // Compress file if it's an image
            const compressedFile =
              file.type.startsWith("image/") &&
              (await imageCompression(file, {
                maxSizeMB: 1, // Compress to 1MB or less
                useWebWorker: true,
              }));

            // Update status to "Completed"
            setCompressionStatus((prevStatus) =>
              prevStatus.map((status, i) =>
                i === index ? { ...status, status: "Completed" } : status
              )
            );

            return compressedFile || file; // Return compressed file or original file if not an image
          } catch (error) {
            // Update status to "Failed"
            setCompressionStatus((prevStatus) =>
              prevStatus.map((status, i) =>
                i === index ? { ...status, status: "Failed" } : status
              )
            );
            console.error(`Error compressing ${file.name}:`, error);
            return file; // Return original file on error
          }
        })
      );

      setFiles(compressedFiles); // Update with compressed files

    };
    


    return (
      <Card className="w-full sm:w-96 mb-10 sm:mb-0">
        <CardHeader
          variant="gradient"
          color="gray"
          className="mb-4 grid place-items-center rounded-lg h-20 bg-gradient-to-r from-cyan-500 to-blue-500" 
        >
          <Typography variant="h4" color="white" className="">
            Get a free quote
          </Typography>
        </CardHeader>
        <form onSubmit={(event) => checkFileSize(event, setCompressionStatus, setDownloadURL)}>
        <CardBody className="flex flex-col gap-4">
            
          { inquiryText === 'y' ?
              <Button type="button" variant='outlined' color='green' size='lg' className="flex text-center text-xs tracking-wider font-light my-2 rounded-full"><FaRegCircleCheck size={16} />&nbsp;Inquiry Submitted</Button>
          : inquiryText === 'x' ?
              <Button type="button" variant='outlined' color='red' size='lg' className="flex text-center text-xs tracking-wider font-light my-2 rounded-full"><IoWarning size={16} />&nbsp;Oops..! An Error Occured</Button>
          :null }

          <div>
            <Input type="text" label="Firstname" size="lg" icon={<HiOutlineUser />} name="fname" value={formFields.fname} onChange={changeFieldText} required/>
          </div>
          <div>
            <Input type="text" label="Last Name" size="lg" icon={<HiOutlineUser />} name="sname" value={formFields.sname} onChange={changeFieldText} required/>
          </div>
          <div>
            <Input type="email" label="Email" size="lg" icon={<HiOutlineEnvelope />} name="email" value={formFields.email} onChange={changeFieldText} required/>
          </div>
          <div>
            <Input type="number" min={0} label="Phone" size="lg" icon={<AiOutlinePhone />} name="phone" value={formFields.phone} onChange={changeFieldText} required/>
          </div>
          <div>
            <Input type="text" label="Organization" size="lg" icon={<HiOutlineBuildingLibrary />} name="org" value={formFields.org} onChange={changeFieldText} />
          </div>
          <Typography variant="h6" className="leading-5 px-2">Upload Your File(s) Here
              <span className="italic text-blue-500 font-light text-sm"> (Optional)</span>
          </Typography>
          <div>
            <input className="uploadBtn w-full" 
            type="file" 
            multiple
            name="upfiles"
            // onChange={handleFileSelect}
            // onChange={(event) => handleFileSelect(event, setCompressionStatus, setDownloadURL)}
            accept="image/*,.txt,.pdf,.docx"
            label="Phone" size="lg" icon={<AiOutlinePhone className="fas fa-heart" />} />
          </div>

          {/* {downloadURL && (
            <div>
              <h3>Download Link:</h3>
              <a href={downloadURL} target="_blank" rel="noopener noreferrer">
                Download ZIP File
              </a>
            </div>
          )} */}
      
          <div className="comp-stat px-2">
            <ul>
              {compressionStatus === 'completed' ? (
                <li>
                  <FaCheck className="text-green-500 float-left m-0.5 mr-1" /> Upload Complete
                </li>
              ) : compressionStatus === 'completed' ? (
                <li><IoWarning className="text-yellow-500 float-left m-0.5 mr-1" />Uploading...</li>
              ) : (null
              )}
            </ul>
          </div>

          <Typography variant="h6" className="leading-5 px-2">Additional Information & Requested Language(s)
            <span className="italic text-red-500 font-light text-sm"> (Required)</span>
          </Typography>
          <div className="">
            <Textarea maxLength={500} label="Enter Message" name="message" value={formFields.message} onChange={changeFieldText} required/>
            <p className="text-xs font-light">Note: 500 maximum characters</p>
          </div>
        </CardBody>
        <CardFooter className="pt-0">
          <Button type="submit" variant="gradient" className="bg-violet-950" fullWidth>
            Send Request
          </Button>
          <Typography variant="small" className="mt-6 flex justify-center text-violet-700">
            Already a member?
            <Typography
              as="a"
              href="#signup"
              variant="small"
              color="blue-gray"
              className="ml-1 font-bold"
            >
              Follow Up!
            </Typography>
          </Typography>
        </CardFooter>
        </form>
      </Card>
    );
  }